import { useSearchParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import HotList from "./components/HotList";
import Specials from "./components/Specials";
import Updates from "./components/Updates";
import Faq from "./components/Faq";
import SearchResults from "./components/SearchResults";
import { faqs, animeList } from "@/mocks/anime";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const listLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "妖精动漫网热门奇幻番剧",
  itemListElement: animeList.slice(0, 6).map((a, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: a.title,
    url: `https://updateline.github.io/anime/${a.id}`,
  })),
};

export default function Home() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([faqLd, listLd]) }}
      />
      <Navbar />
      <main>
        <Hero />
        {q && <SearchResults q={q} />}
        <Categories />
        <HotList />
        <Specials />
        <Updates />
        <Faq />
      </main>
      <Footer />
    </>
  );
}